import { NewDeviceModel } from "../model/device-model";
import { DeviceIcon } from "./device-icons";

export enum EAutomationClass {
    CLASS_UNKNOWN = 0,
    CLASS_SLIDING_GATE = 1,
    CLASS_SWING_GATE = 2,
    CLASS_TILTING_DOOR = 3,
    CLASS_BARRIER = 4,
    CLASS_SHUTTER = 5,
    CLASS_AUTOMATIC_DOOR = 11,
    CLASS_TURNSTILE = 32,
    CLASS_BALCONY = 51,
    CLASS_IO = 80,
    CLASS_SUBGATEWAY = 1000 //Add fake class
}

export const isAutomationClassGroupable = (automationClass: number): boolean => automationClass !== EAutomationClass.CLASS_BALCONY;

export enum EGenericBoardId {
    BOARD_ID_UNKNOWN = 0
}

export enum ESlidingGatesBoardId {
    BOARD_ID_ZBKE = 1,
    BOARD_ID_ZN7 = 2,
    BOARD_ID_ZN7V = 3,
    BOARD_ID_ZBX7N = 4,
    BOARD_ID_ZBKN = 5,
    BOARD_ID_ZN8 = 6
}

export enum ESwingGatesBoardId {
    BOARD_ID_ZLJ24 = 1,
    BOARD_ID_ZM3 = 2,
    BOARD_ID_ZL65 = 3,
    BOARD_ID_ZLJ4E_SMED = 4,
    BOARD_ID_ZLJ4E_TOP = 5
}

export enum ETiltingDoorsBoardId {
    BOARD_ID_ZL57 = 1
}

export enum EBarriersBoardId {
    BOARD_ID_ZL39 = 1,
    BOARD_ID_ZLB30A = 3,
    BOARD_ID_ZL39EX = 4,
    BOARD_ID_ZLB30B = 5,
    BOARD_ID_ZL392 = 6
}

export enum ETurnstilesBoardId {
    BOARD_ID_TOR200 = 2,
    BOARD_ID_TOR300 = 3,
    BOARD_ID_TOR400 = 4,
    BOARD_ID_TOR500 = 5
}

export enum EShuttersBoardId {
    BOARD_ID_ZVL2 = 1
}

export enum EIOBoardId {
    BOARD_ID_RBE4 = 1,
    BOARD_ID_IORS485 = 2
}

export const compatibilityMap: Map<string, number> = new Map<string, number>([
    [EAutomationClass.CLASS_SLIDING_GATE + '-' + ESlidingGatesBoardId.BOARD_ID_ZN7, 288],
    [EAutomationClass.CLASS_SLIDING_GATE + '-' + ESlidingGatesBoardId.BOARD_ID_ZN7V, 288],
    [EAutomationClass.CLASS_SLIDING_GATE + '-' + ESlidingGatesBoardId.BOARD_ID_ZBX7N, 288],
    [EAutomationClass.CLASS_SLIDING_GATE + '-' + ESlidingGatesBoardId.BOARD_ID_ZBKN, 288],
    [EAutomationClass.CLASS_SLIDING_GATE + '-' + ESlidingGatesBoardId.BOARD_ID_ZN8, 272],
    [EAutomationClass.CLASS_SWING_GATE + '-' + ESwingGatesBoardId.BOARD_ID_ZLJ24, 285],
    [EAutomationClass.CLASS_SWING_GATE + '-' + ESwingGatesBoardId.BOARD_ID_ZM3, 285],
    [EAutomationClass.CLASS_SWING_GATE + '-' + ESwingGatesBoardId.BOARD_ID_ZL65, 288],
    [EAutomationClass.CLASS_SWING_GATE + '-' + ESwingGatesBoardId.BOARD_ID_ZLJ4E_SMED, 288],
    [EAutomationClass.CLASS_SWING_GATE + '-' + ESwingGatesBoardId.BOARD_ID_ZLJ4E_TOP, 272],
    [EAutomationClass.CLASS_TILTING_DOOR + '-' + ETiltingDoorsBoardId.BOARD_ID_ZL57, 288],
    [EAutomationClass.CLASS_BARRIER + '-' + EBarriersBoardId.BOARD_ID_ZLB30A, 288],
    [EAutomationClass.CLASS_BARRIER + '-' + EBarriersBoardId.BOARD_ID_ZLB30B, 288],
    [EAutomationClass.CLASS_SHUTTER + '-' + EShuttersBoardId.BOARD_ID_ZVL2, -1],
    [EAutomationClass.CLASS_IO + '-' + EIOBoardId.BOARD_ID_RBE4, 280],
]);

export const AUTOMATION_CLASS_LIST: NewDeviceModel[] = [
    {
        BoardClass: EAutomationClass.CLASS_SLIDING_GATE,
        IconName: DeviceIcon.slidingGate0,
        BoardName: 'CLASS_SLIDING_GATE'
    },
    {
        BoardClass: EAutomationClass.CLASS_SWING_GATE,
        IconName: DeviceIcon.swingGate0,
        BoardName: 'CLASS_SWING_GATE'
    },
    {
        BoardClass: EAutomationClass.CLASS_TILTING_DOOR,
        IconName: DeviceIcon.garage,
        BoardName: 'CLASS_TILTING_DOOR'
    },
    {
        BoardClass: EAutomationClass.CLASS_BARRIER,
        IconName: DeviceIcon.barrier0,
        BoardName: 'CLASS_BARRIER'
    },
    /*{
        BoardClass: EAutomationClass.CLASS_AUTOMATIC_DOOR,
        IconName: DeviceIcon.automaticDoor0,
        BoardName: 'CLASS_AUTOMATIC_DOOR'
    },
    {
        BoardClass: EAutomationClass.CLASS_TURNSTILE,
        IconName: DeviceIcon.turnStile1,
        BoardName: 'CLASS_TURNSTILE'
    },*/
    {
        BoardClass: EAutomationClass.CLASS_SHUTTER,
        IconName: DeviceIcon.shutter,
        BoardName: 'CLASS_SHUTTER'
    },
    {
        BoardClass: EAutomationClass.CLASS_BALCONY,
        IconName: DeviceIcon.tapparella,
        BoardName: 'CLASS_BALCONY'
    },
    {
        BoardClass: EAutomationClass.CLASS_IO,
        IconName: DeviceIcon.rbe,
        BoardName: 'CLASS_IO'
    },
    {
        BoardClass: EAutomationClass.CLASS_SUBGATEWAY,
        IconName: DeviceIcon.Gateway,
        BoardName: 'CLASS_SUBGATEWAY'
    },
];
